import { render } from "./ContactsComponent.vue?vue&type=template&id=ec27592c&scoped=true"
import script from "./ContactsComponent.vue?vue&type=script&lang=js"
export * from "./ContactsComponent.vue?vue&type=script&lang=js"

import "./ContactsComponent.vue?vue&type=style&index=0&id=ec27592c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec27592c"]])

export default __exports__